<script>
  import { time_ranges_to_array } from "svelte/internal";

	// export let avatar;
	export let key;
	export let nama;
	export let npm;
	export let jenjang;
	export let prodi;
	export let fakultas;

	function copyToClipboard() {
		const text = `${nama} - ${npm}`;
		navigator.clipboard.writeText(text)
			.then(() => {
				// alert("Text copied to clipboard!");
				return true;
			})
			.catch((err) => {
				alert("Failed to copy text: ", err);
				console.error("Failed to copy text: ", err);
			});
	}
</script>

<div class='card'>
	<!-- <span class='avatar' style='background: url({avatar})' ></span> -->
	<h2>{nama}</h2>
	<p>{npm}</p>
	<p>{jenjang}</p>
	<p>{prodi}</p>
	<p>{fakultas}</p>
	<button class="copy-button" on:click={copyToClipboard}>Salin</button>
</div>

<style>
	.card {
		align-items: center;
		position: relative;
		margin: 0.2em;
		padding: 2em 2em 2em 2em;
		border: 2.5px solid #eee;
		border-radius: 4px;
		box-shadow: 2px 2px 4px rgba(0,0,0,0.1);
		min-height: 5em;
	}

	.card::after {
		clear: both;
		display: block;
	}

	/* .avatar {
		position: absolute;
		width: 5em;
		height: 5em;
		left: 0.5em;
		top: 0.5em;
		border-radius: 50%;
		background: no-repeat 50% 50%;
		background-size: cover;
	} */

	h2 {
		margin: 0 0 0.5em 0;
		font-size: 16px;
	}

	p {
		margin: 0;
		font-size: 14px;
	}

	.copy-button {
		background-color: #4caf50;
		color: white;
		padding: 2.5px 5px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		margin-top: 10px;
		font-size: smaller;
	}

	.copy-button:hover {
		background-color: #45a049;
	}
</style>